const bpla = {
  hero: {
    title: 'ВИРОБЛЕНИЙ В УКРАЇНІ. ПЕРЕВІРЕНИЙ У БОЮ. КОДИФІКОВАНИЙ МІНОБОРОНИ.',
    description:
      'БПЛА PEGASUS ARMS 25 — ударний квадрокоптер нового покоління української розробки. Перевірений у бойових умовах, має високу стійкість до засобів РЕБ, стабільний радіозв’язок і телеметрію. Розроблений спільно інженерами та військовими фахівцями, дрон допущений до експлуатації наказом Міноборони у січні 2024 року. Оснащений адаптивною електронікою та системою автономного повернення на базу у разі втрати зв’язку.',
    paragraphs: [
      'Основне призначення Pegasus Arms 25 — це ударні місії по ворожій бронетехніці, автотранспорту та живій силі. Окрім цього, БпЛА застосовується для нейтралізації інженерних споруд, дистанційного мінування та логістики. Доставка спорядження, БК, медикаментів, провіанту — все це під силу Pegasus Arms 25.',
      'Модульна система БпЛА дозволяє використовувати різноманітне бойове навантаження:',
    ],
    cards: [
      'Протитанкові міни',
      'Інженерні боєприпаси (дистанційне мінування)',
      'Бойова частина для ураження',
      'Спеціалізовані засоби доставки (медикаменти, вода, БК)',
    ],
  },
  results: {
    title: 'Бойові результати',
    paragraphs: [
      'У лютому 2024 року ударний БпЛА Pegasus Arms 25 був використаний для знищення російської важкої вогнеметної системи ТОС-1А "Солнцепьок". Але це не єдина вдала місія цього бойового птаха. Свою ефективність Pegasus Arms 25 довів у понад 1000-і вдало виконаних завданнях.',
      'Pegasus Arms 25 — бойовий дрон української розробки, перевірений на передовій. Має стабільний зв’язок, стійкість до РЕБ і бойову автономність, адаптується під завдання підрозділу. Понад 50 бригад Сил оборони використовують його для ураження техніки, споруд і живої сили, підвищуючи ефективність дій на полі бою.',
    ],
  },
  integration: {
    title: 'Державні платформи',
    paragraphs: [
      'БпЛА/ БпАК Pegasus Arms 25  офіційно представлений на маркетплейсі',
      'Його можуть замовляти військові частини  в рамках програми «Армія Дронів Бонус» за нараховані «Е-Бали». Постачання та облік здійснюється через DOT-chain Defence.',
    ],
    link: 'Brave1Market.',
  },
}

export default bpla
